import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  Response,
  TransactionStatusLog,
  BaseellaStatusTransition,
} from '@ui/src';
import { statusesTransactionsApi } from './services';

export interface StatusesState {
  statuses?: {
    prevStatus?: BaseellaStatusTransition[];
    nextStatus?: BaseellaStatusTransition[];
  };
  statusLogs?: TransactionStatusLog[];
}

const initialState: StatusesState = {
  statuses: undefined,
};

export const statuses = createSlice({
  name: 'statuses',
  initialState,
  reducers: {
    clearStatusesState: (state) => {
      state.statuses = undefined;
      state.statusLogs = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        statusesTransactionsApi.endpoints.getStatusesTransactionById
          .matchFulfilled,
        (
          state,
          action: PayloadAction<{
            data: {
              prev: BaseellaStatusTransition[];
              next: BaseellaStatusTransition[];
            };
          }>,
        ) => {
          state.statuses = {
            ...state.statuses,
            prevStatus: action.payload.data?.prev?.length
              ? action.payload.data?.prev
              : undefined,
            nextStatus: action.payload.data?.next?.length
              ? action.payload.data?.next
              : undefined,
          };
        },
      )
      .addMatcher(
        statusesTransactionsApi.endpoints.getTransactionLogs.matchFulfilled,
        (state, action: PayloadAction<Response<TransactionStatusLog>>) => {
          state.statusLogs = action.payload.data.edges?.map(
            (item) => item.node,
          );
        },
      );
  },
});

export const { clearStatusesState } = statuses.actions;

export default statuses.reducer;
